import React, { useEffect, useMemo, useState } from "react";
import { Link } from "@quintype/components";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { shortenUrl } from "../../../../../api/utils";
import { getStoryHeadline } from "../../../utils/story";

import "./social-share-icons.m.css";
import { set } from "lodash";

export default function SocialShareIcons({ story, imageDimension, isGnreach = false }) {
  const [shareMenuOpen, setShareMenuOpen] = useState(false);
  const [copyPopupOpen, setCopyPopupOpen] = useState(false);
  const [shortStoryUrl, setShortStoryUrl] = useState(story?.url);
  const { width, height, viewbox } = imageDimension;
  const headline = getStoryHeadline(story);

  const getShareUrl = async (name) => {
    const newUrl = await fetchShortUrl();
    let sUrl;
    switch (name) {
      case "Facebook":
        sUrl = `https://www.facebook.com/sharer.php?u=${newUrl}`;
        break;
      case "X":
        sUrl = `https://twitter.com/intent/tweet?url=${newUrl}&text=${encodeURIComponent(headline)}`;
        break;
      case "Whatsapp":
        sUrl = `https://api.whatsapp.com/send?text=${newUrl}`;
        break;
    }
    window.open(sUrl, "_blank", "noopener ,noreferrer");
  };
  const fetchShortUrl = async () => {
    try {
      // Check if we already have this URL in sessionStorage
      const cachedUrl = sessionStorage.getItem(story?.url);
      if (cachedUrl) {
        setShortStoryUrl(cachedUrl);
        return cachedUrl;
      }

      // If not cached, fetch new shortened URL
      const data = await shortenUrl(story?.url);
      if (data?.shortUrl) {
        // Store in sessionStorage for future use
        sessionStorage.setItem(story?.url, data.shortUrl);
        setShortStoryUrl(data.shortUrl);
        return data.shortUrl;
      }
      return story?.url;
    } catch (err) {
      console.error("Failed to shorten URL: ", err);
      console.log(story?.url);
      return story?.url;
    }
  };
  const iconSet = useMemo(
    () => [
      {
        id: isGnreach ? "hamburger-facebook" : "share-facebook",
        label: "Facebook",
        url: `https://www.facebook.com/sharer.php?u=${shortStoryUrl}`,
      },
      {
        id: isGnreach ? "hamburger-twitter" : "share-x",
        label: "X",
        url: `https://twitter.com/intent/tweet?url=${shortStoryUrl}&text=${encodeURIComponent(headline)}`,
      },
      {
        id: isGnreach ? "hamburger-whatsapp" : "share-whatsapp",
        label: "Whatsapp",
        url: `https://api.whatsapp.com/send?text=${shortStoryUrl}`,
      },
    ],
    [shortStoryUrl]
  );

  const shareIconSet = useMemo(
    () => [
      ...iconSet,
      {
        id: isGnreach ? "share-mail-gnreach" : "share-mail",
        label: "E-mail",
        url: `mailto:?subject=${story.headline}&body=${shortStoryUrl}`,
      },
      {
        id: isGnreach ? "hamburger-linkedin" : "share-linkedin",
        label: "Linkedin",
        url: `https://www.linkedin.com/shareArticle?url=${shortStoryUrl}&title=${encodeURIComponent(headline)}`,
      },
    ],
    [iconSet, shortStoryUrl, story?.headline]
  );
  const icon = { width, height, viewBox: viewbox };

  const copyLink = isGnreach ? "share-link-gnreach" : "share-link";
  const shareMenu = isGnreach ? "share-menu-gnreach" : "share-menu";

  useEffect(() => {
    // Function to handle clicks outside of share menu
    const handleClickOutside = (event) => {
      if (shareMenuOpen && !event.target.closest('[styleName="share-menu-container"]')) {
        setTimeout(() => {
          setShareMenuOpen(false);
        }, 500);
      }
    };

    if (shareMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [shareMenuOpen]);

  return (
    <span styleName="share">
      {iconSet.map((item, index) => {
        return (
          <div key={index} onClick={() => getShareUrl(item?.label)}>
            <SvgIconHandler type={item.id} height={icon.height} width={icon.width} viewBox={icon.viewBox} />
          </div>
        );
      })}
      <span
        styleName="copy-link-container"
        tabIndex={0}
        onClick={async () => {
          const newUrl = await fetchShortUrl();
          // setShareMenuOpen(true);
          navigator.clipboard.writeText(newUrl || shortStoryUrl);
          setCopyPopupOpen(true);
          setTimeout(() => {
            setCopyPopupOpen(false);
          }, 4000);
        }}
      >
        <SvgIconHandler type={copyLink} height={icon.height} width={icon.width} viewBox={icon.viewBox} />
        {copyPopupOpen && <span styleName="copy-link">Link copied!</span>}
      </span>
      <span
        tabIndex={0}
        styleName="share-menu-container"
        onClick={async () => {
          // Toggle menu if already open
          if (shareMenuOpen) {
            setTimeout(() => {
              setShareMenuOpen(false);
            }, 300);
            return;
          }
          await fetchShortUrl();
          setShareMenuOpen(true);
          setTimeout(() => {
            setShareMenuOpen(false);
          }, 30000);
        }}
      >
        <SvgIconHandler type={shareMenu} height={icon.height} width={icon.width} viewBox={icon.viewBox} />
        {shareMenuOpen && (
          <div styleName="share-menu">
            {shareIconSet.map((item, index) => {
              return (
                <Link key={index} href={item?.url} target="_blank">
                  <SvgIconHandler type={item.id} height="32px" width="32px" viewBox="0 0 32 32" />
                  <span>{item?.label}</span>
                </Link>
              );
            })}
            <div
              styleName="copy-link-container-2"
              onClick={() => {
                navigator.clipboard.writeText(shortStoryUrl);
                setCopyPopupOpen(true);

                setTimeout(() => {
                  // setShareMenuOpen(false);
                }, 300);

                setTimeout(() => {
                  setCopyPopupOpen(false);
                }, 4000);
              }}
            >
              <SvgIconHandler type={copyLink} height="32px" width="32px" viewBox="0 0 32 32" />
              <span id="copy-link">Copy link</span>
            </div>
          </div>
        )}
      </span>
    </span>
  );
}
